import { useTranslation } from 'react-i18next';

import { Button, Grid } from '@mui/material';
import { useFormikContext } from 'formik';

import { FormikSubmit } from '@/components/formik/FormikSubmit';

import { TStationFuel } from '@/types/station';

import { TAddPumpCommonProps } from '../types';

export const ModalActions = ({ close }: TAddPumpCommonProps) => {
  const { t } = useTranslation();
  const { isValid, dirty, isSubmitting } = useFormikContext<TStationFuel>();

  const isSubmitBtnDisabled = !isValid || !dirty || isSubmitting;

  return (
    <Grid item xs={12} gap={2}>
      <Button variant="outlined" onClick={() => close('pump.create')} sx={{ flexGrow: 1 }}>
        {t('common.discard')}
      </Button>

      <FormikSubmit disabled={isSubmitBtnDisabled} sx={{ flexGrow: 1 }}>
        {t('common.save')}
      </FormikSubmit>
    </Grid>
  );
};
